import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import Frontpage from "./pages/Frontpage";
import PostDetail from "./pages/PostDetail";
import Rankings from "./pages/Rankings";
import Authors from "./pages/Authors";
import BeatnikProfile from "./pages/BeatnikProfile";
import MyProfile from "./pages/MyProfile";
import Editor from "./pages/Editor";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AdminPanel from "./pages/AdminPanel";
import Notifications from "./pages/Notifications";
import ProtectedRoute from "./components/ProtectedRoute";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import SupabaseCallback from "./pages/SupabaseCallback";
import { TheEdition } from "./components/TheEdition";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

function App() {
  return (
    <AuthProvider>
      <Layout>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Frontpage />} />
          <Route path="/post/:id" element={<PostDetail />} />
          <Route path="/thepulse" element={<Rankings />} />
          <Route path="/voices" element={<Authors />} />
          <Route path="/voice/:username" element={<BeatnikProfile />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/auth/callback" element={<SupabaseCallback />} />

          {/* Protected routes */}

          <Route
            path="/the-edition"
            element={
              <ProtectedRoute>
                <TheEdition />
              </ProtectedRoute>
            }
          />

          <Route
            path="/write"
            element={
              <ProtectedRoute>
                <Editor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <MyProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                <Notifications />
              </ProtectedRoute>
            }
          />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
        </Routes>
      </Layout>
    </AuthProvider>
  );
}

export default App;
